export const EstatusDocumento = {
    NoAplica: 0,
    SIN_DOCUMENTO: 1,
    DOCUMENTO: 2,
}